import { Component, ViewChild } from "@angular/core";
import { UserService } from "../../services/user.service";
import { fadeInOutAnimation, savingButtonAnimation } from "../../animations";

import { Angulartics2 } from "angulartics2";
import { CatalogService } from "@app/services/catalog.service";
import { Listing } from "@app/data/listing";
import { OnInit } from "@angular/core";
import { Catalog } from "@app/data/catalog";
import * as tearSheetUtils from "@js/tear-sheet.utils";
import * as _ from "underscore";
import { Page } from "@app/data/page";
import { SMALL_INVENTORY_LIMIT } from "@app/components/platform/listings-table.component";
import { DigitalOrderSheetService } from "@app/services/digital-order-sheet.service";
import { DigitalOrderSheet } from "@app/data/digital-order-sheet";
import { Plan } from "@app/data/user";
import { SupermodalComponent } from "../common/supermodal.component";

@Component({
  templateUrl: "./digital-order-sheet-configuration.component.html",
  animations: [fadeInOutAnimation, savingButtonAnimation],
})
export class DigitalOrderSheetConfigurationComponent implements OnInit {
  saving: boolean;
  keywords: string = "";
  source: string;
  isNowInStore: boolean = false;
  isShopify: boolean = false;
  digitalOrderSheet: DigitalOrderSheet;
  digitalOrderSheetModel: DigitalOrderSheet;
  catalog: Catalog;
  catalogs: Catalog[] = [];
  _listings: Listing[] = [];
  catalogSource: Catalog;
  rows: Listing[] = [];
  page = new Page();
  plan: Plan;
  @ViewChild("savedConfirmationSupermodal")
  savedConfirmationSupermodal: SupermodalComponent;

  constructor(
    private angulartics2: Angulartics2,
    private catalogService: CatalogService,
    private digitalOrderSheetService: DigitalOrderSheetService,
    private userService: UserService
  ) {
    this.angulartics2.eventTrack.next({ action: "Opened Online Store" });
    this.source = "onlineStore";
    this.page.pageNumber = 0;
    this.setPage({ offset: 0 });
  }

  ngOnInit() {
    this.userService.me().then((user) => {
      this.plan = user.subscription.plan;
      this.isShopify = this.userService.isShopify(user);
      this.isNowInStore = this.userService.isNowInStore;
      this.digitalOrderSheetService.query(1).then((digitalOrderSheets) => {
        if (digitalOrderSheets.length > 0) {
          this.digitalOrderSheetService
            .get(digitalOrderSheets[0]._id)
            .then((digitalOrderSheet) => {
              this.setDigitalOrderSheetModel(digitalOrderSheet);
            });
        } else {
          let digitalOrderSheet = new DigitalOrderSheet();
          digitalOrderSheet.source = "online store";
          digitalOrderSheet.listings = [];
          digitalOrderSheet.selection = [];
          (digitalOrderSheet.display_msrp = true),
            (digitalOrderSheet.thank_you_message = "");
          digitalOrderSheet.default_tax = 0;
          // digitalOrderSheet.default_shipping_rate = 0;

          this.digitalOrderSheetService
            .create(digitalOrderSheet)
            .then((digitalOrderSheet) =>
              this.setDigitalOrderSheetModel(digitalOrderSheet)
            );
        }
      });
    });
  }

  protected setDigitalOrderSheetModel(digitalOrderSheet: DigitalOrderSheet) {
    this.digitalOrderSheet = digitalOrderSheet;
    this.digitalOrderSheetModel = JSON.parse(
      JSON.stringify(this.digitalOrderSheet)
    );
    this.listings = this.digitalOrderSheetModel.listings;
  }

  onUploadSuccess($event, rowIndex) {
    this.rows[rowIndex].images.push($event[1].url);
  }

  filter() {
    console.log("filter called");
    this.rows = [];
    var lowerCaseKeywords = this.keywords.toLowerCase();
    let filteredListings = _.filter(this.listings, (listing) => {
      return (
        (listing.category &&
          listing.category.toLowerCase().includes(lowerCaseKeywords)) ||
        (listing.title &&
          listing.title.toLowerCase().includes(lowerCaseKeywords)) ||
        (listing.description &&
          listing.description.toLowerCase().includes(lowerCaseKeywords)) ||
        (listing.sku && listing.sku.toLowerCase().includes(lowerCaseKeywords))
      );
    });

    this.rows = filteredListings.slice(
      this.page.pageNumber * SMALL_INVENTORY_LIMIT,
      Math.min(
        this.page.pageNumber * SMALL_INVENTORY_LIMIT + SMALL_INVENTORY_LIMIT,
        filteredListings.length
      )
    );
    this.page.size = this.rows.length;
    this.page.totalElements = this.listings.length;
    this.page.totalPages = Math.ceil(this.rows.length / SMALL_INVENTORY_LIMIT);
  }

  private setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    this.page.size = SMALL_INVENTORY_LIMIT;
  }

  protected loadCatalogs() {
    this.catalogService.getCatalogs("", 0).then((catalogs) => {
      this.catalogs = catalogs;
      if (this.catalogs.length > 0) {
        this.catalogs.sort(function (a, b) {
          return a.title.toLowerCase().localeCompare(b.title.toLowerCase());
        });
        this.catalogSource = this.catalogs[0];
        this.catalogSourceChanged(this.catalogSource);
      }
    });
  }

  protected catalogSourceChanged(catalog: Catalog) {
    console.log("load catalog source", catalog._id);
    this.catalogService.getCatalog(catalog._id).then((catalog) => {
      this.catalog = catalog;
      if (!this.catalog.listings) {
        tearSheetUtils.initListingsCategories(this.catalog);
      }
      if (this.source === "catalog") {
        this.listings = catalog.listings;
      }
    });
  }

  private set listings(listings: Listing[]) {
    var existingListings = this._listings;
    this._listings = [];
    listings.forEach((listing) => {
      var idKey = listing.id ? "id" : "_id";
      var foundListing = _.findWhere(existingListings, <any>{
        idKey: listing[idKey],
      });
      console.log(listing, foundListing, foundListing || listing);
      this._listings.push(foundListing || listing);
    });
    this.filter();
  }

  private get listings(): Listing[] {
    return this._listings;
  }

  protected sourceChanged() {
    this.listings = [];
    if (this.source === "catalog") {
      console.log("load catalogs");
      this.loadCatalogs();
    }
  }

  protected listingsChanged(listings: Listing[]) {
    this.listings = listings;
  }

  protected submitDocument(openStore: boolean = false) {
    this.digitalOrderSheetModel.listings = this.listings;
    this.saving = true;
    this.digitalOrderSheetService
      .update(this.digitalOrderSheetModel)
      .then((digitalOrderSheet) => {
        this.saving = false;
        this.savedConfirmationSupermodal.open();
        this.setDigitalOrderSheetModel(digitalOrderSheet);
        if (openStore) {
          window.open(
            `/digital-order-sheets/${this.digitalOrderSheet._id}/view`
          );
        }
      });
  }
  protected openStore() {
    this.submitDocument(true);
  }
}
